import React, { Component } from 'react';
import Select, { components } from "react-select";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

import './EditSelect.scss';


class EditSelect extends Component {
	
	filter(candidate, string) {
		const object = candidate['data'];
		for(var prop in object) {
			if ((typeof object[prop] === 'string' || object[prop] instanceof String)  && object[prop].toLowerCase().includes(string.toLowerCase()))
				return true;
		}
		return false;
		
	}

	opt(props) {
		return <div>
			<components.Option {...props}>
				<div className="edit-option">
					<label>{props.label}</label>
					{this.props.onEditClick !== false &&
						<button className="clear" onClick={(e) => {this.props.onEditClick(e, props.data);}}><FontAwesomeIcon icon={faEdit} className="editIcon" /></button>
					}
				</div>
			</components.Option>
		</div>;
	}
	
	
	
	render() {
		const Option = this.opt.bind(this);
		return (
			<div>
				<Select
					defaultValue={this.props.defaultValue}
					value={this.props.value}
					label={this.props.label || ''}
					options={this.props.options}
					onChange={this.props.onChange}
					filterOption={this.props.filterOption || this.filter}
					components={{ Option }}
				/>
			</div>
		);
	}
}

export default EditSelect;
